import { For, Show } from "solid-js";
import { A } from "@solidjs/router";
import { ExternalLink } from "lucide-solid";
import { useLocale } from "@/context/locale";

export default function ProjectInfobox(props) {
  const { t, prefix, locale } = useLocale();
  const projectHref = () => `${prefix}/portfolio/${props.project.slug}`;

  const rows = () => {
    const p = props.project;
    return [
      ...(p.lang ? [{ label: t("portfolio.info.language"), value: p.lang }] : []),
      ...(p.updatedAt
        ? [{
            label: t("portfolio.info.updated"),
            value: new Intl.DateTimeFormat(locale, { timeZone: "UTC", year: "numeric", month: "long" }).format(new Date(p.updatedAt)),
          }]
        : []),
      ...(p.url ? [{ label: t("portfolio.info.repository"), value: p.url.replace(/^https?:\/\/(www\.)?github\.com\//, ""), href: p.url }] : []),
      ...(p.homepage ? [{ label: t("portfolio.info.website"), value: p.homepage.replace(/^https?:\/\//, "").replace(/\/$/, ""), href: p.homepage }] : []),
    ];
  };

  return (
    <aside class={`glass-panel rounded-2xl overflow-hidden ${props.class ?? ""}`}>
      <div class="px-4 py-3 bg-muted text-center">
        <span class="text-lg font-bold text-foreground">{props.project.name}</span>
      </div>
      <dl class="grid grid-cols-[100px_1fr]">
        <For each={rows()}>
          {(row) => (
            <>
              <dt class="px-4 py-2.5 text-xs font-semibold text-foreground border-b border-border">{row.label}</dt>
              <dd class="px-4 py-2.5 text-xs text-muted-foreground border-b border-border break-words min-w-0">
                <Show when={row.href} fallback={row.value}>
                  <a href={row.href} target="_blank" rel="noopener" class="inline-flex items-center gap-1 text-foreground underline underline-offset-4 hover:text-muted-foreground transition-colors break-all">
                    {row.value}
                    <ExternalLink size={11} class="shrink-0" />
                  </a>
                </Show>
              </dd>
            </>
          )}
        </For>
      </dl>
      <Show when={props.project.pages?.length}>
        <div class="px-4 py-2 bg-muted text-center">
          <span class="text-sm font-bold text-foreground">{t("portfolio.info.chapters")}</span>
        </div>
        <ol class="flex flex-col">
          <For each={props.project.pages}>
            {(pg) => (
              <li class="border-b border-border last:border-b-0">
                <A
                  href={`${projectHref()}/${pg.slug}`}
                  class={`block px-4 py-2.5 text-xs transition-colors hover:text-foreground ${pg.slug === props.activePage ? "text-foreground font-semibold" : "text-muted-foreground"}`}
                >
                  {pg.title}
                </A>
              </li>
            )}
          </For>
        </ol>
      </Show>
    </aside>
  );
}
